import PhoneInput from './PhoneInput';
import withReadyOnlyAbility from '../ReadOnlyAbilityWrapper';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(withReadyOnlyAbility(PhoneInput));
